import {
  SubtenantDto,
  QueryFactory,
  defaultThrowOnError,
} from '@lmt/shared-types';
import { useMemo } from 'react';
import { emptyArray } from '../../helpers/common';

export function useSubtenants(): SubtenantDto[] {
  return (
    QueryFactory.TenantQuery.useGetSubtenantsQuery(
      {},
      { throwOnError: defaultThrowOnError },
    ).data?.data ?? emptyArray()
  );
}
export function useSubtenantsDict(): { [key: number]: SubtenantDto } {
  const subtenants: SubtenantDto[] = useSubtenants();
  const subtenantsDict = useMemo(() => {
    const dict: { [key: number]: SubtenantDto } = {};
    subtenants.forEach((subtenant) => {
      dict[subtenant.id] = subtenant;
    });
    return dict;
  }, [subtenants]);
  return subtenantsDict;
}

export function useSubtenant(subtenantId: number): SubtenantDto;
export function useSubtenant(
  subtenantId: number | undefined,
): SubtenantDto | undefined;
export function useSubtenant(
  subtenantId: number | undefined,
): SubtenantDto | undefined {
  const subtenantsDict = useSubtenantsDict();
  return subtenantId ? subtenantsDict[subtenantId!] : undefined!;
}

export function useSelectedSubtenants(
  subtenantIds: (number | null)[] | undefined,
): SubtenantDto[] {
  const subtenants: SubtenantDto[] = useSubtenants();
  const subtenantsDict = useSubtenantsDict();
  const selectedSubtenants = useMemo<SubtenantDto[]>(
    () =>
      subtenantIds?.length
        ? subtenantIds
            .filter((subtenantId) => subtenantId && subtenantsDict[subtenantId])
            .map((subtenantId) => subtenantsDict[subtenantId!])
        : subtenants,
    [subtenantIds, subtenantsDict],
  );
  return selectedSubtenants;
}
